/*
 * File: DemographicsDataModel.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice. All rights reserved.
 *
 * Description: Patient data model to be used for the state tree (So far, this data is actually Person data)
 */

import { types } from "mobx-state-tree";
import PhoneModel from "./PhoneModel";
import FeeSchedule from "../../provider_office_fee/store/FeeSchedule";
import Office from "../../provider_office_fee/store/Office";
import Provider from "../../provider_office_fee/store/Provider";
import { DateFromString } from "utils/DateFromString";

const DemographicsDataModel = {
  patientId: types.maybe(types.number),
  displayId: types.maybe(types.string),
  accountId: types.maybe(types.number),
  firstName: types.maybe(types.string),
  lastName: types.maybe(types.string),
  middle: types.maybe(types.string),
  prefix: types.maybe(types.string),
  suffix: types.maybe(types.string),
  maidenName: types.maybe(types.string),
  nickname: types.maybe(types.string),
  birthdate: types.maybeNull(DateFromString),
  sex: types.maybe(types.number),
  age: types.maybe(types.string),
  governmentIdentifier: types.maybe(types.string),
  maritalStatus: types.maybe(types.number),
  employment: types.maybe(types.number),
  preferredLanguageId: types.maybe(types.number),
  relationshipToPrimary: types.maybe(types.number),
  relationshipToSecondary: types.maybe(types.number),
  streetAddress: types.maybe(types.string),
  suite: types.maybe(types.string),
  city: types.maybe(types.string),
  state: types.maybe(types.string),
  zipCode: types.maybe(types.string),
  country: types.maybe(types.string),
  phone1: types.maybeNull(PhoneModel),
  phone2: types.maybeNull(PhoneModel),
  phone3: types.maybeNull(PhoneModel),
  email: types.maybe(types.string),
  accountProvider: types.optional(Provider, {}),
  patientProvider: types.optional(Provider, {}),
  patientOffice: types.optional(Office, {}),
  feeSchedule: types.optional(FeeSchedule, {})
};

export default DemographicsDataModel;
